<template>
  <div>
    <div class="cal-sans-regular black--text font-size-28 pb-2 mt-3">Lesson Editor</div>
  </div>
</template>

<script>
export default {
  name: 'LessonEditor',
}
</script>